import { useTranslation, Trans } from 'react-i18next'
import { showTrustScoreInfoModal } from './base'
import InfoIcon from './info-icon'
import collection from './images/collection.png'

const CollectionsRecord = props => {
  const { t } = useTranslation()

  return (
    <InfoIcon
      {...props}
      onClick={() =>
        showTrustScoreInfoModal({
          title: t('b.liv_score.view.collections_record.title', 'Collections Record'),
          description: (
            <Trans i18nKey="b.liv_score.view.collections_record.text">
              The <strong>Collections Record</strong> displays the number of a renter's accounts
              that have been assigned to a Collections Agency, if any exist. Generally, this
              information will remain on a renter's Equifax®️ credit report for 6 years following
              the date of the final payment.
            </Trans>
          ),
          image: collection
        })
      }
    />
  )
}

export default CollectionsRecord
